<div *ngIf="!loading" [@fadeInOut]>
  <div class="row">
    <div class="col">
      <ng-container *ngIf="filter" [ngSwitch]="filter['type']">
        <ng-container *ngSwitchCase="'TimeCull'" class="w-100 text-center">
          <sb-calendar-month [dateTimeRanges]="dateTimeRanges" (chosenMonthChanged)="checkForUpdate($event)">
          </sb-calendar-month>
        </ng-container>
        <ng-container *ngSwitchCase="'GeoCull'" class="w-100 text-center">
          <div [ngClass]="filter.id? 'cursor-pointer a-tag' : 'cursor-none'">
            <div class="d-flex underline" (click)="openInventory('GeoCull', 0)">
              <sb-icon icon="companyClient" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('publishers') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('GeoCull',1 )">
              <sb-icon icon="stele" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('channels') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('GeoCull',2)">
              <sb-icon icon="marker" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('markers') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('GeoCull',3)">
              <sb-icon icon="location" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('locations') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('GeoCull',4)">
              <sb-icon icon="playerOnline" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('devices') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('GeoCull',5)">
              <sb-icon icon="screen" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('screens') }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'PlayerCull'" class="w-100 text-center">
          <div [ngClass]="filter.id? 'cursor-pointer a-tag' : 'cursor-none'">
            <div class="d-flex underline" (click)="openInventory('PlayerCull',0)">
              <sb-icon icon="companyClient" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('publishers') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('PlayerCull',1)">
              <sb-icon icon="stele" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('channels') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('PlayerCull',2)">
              <sb-icon icon="marker" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('markers') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('PlayerCull',3)">
              <sb-icon icon="location" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('locations') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('PlayerCull',4)">
              <sb-icon icon="playerOnline" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('devices') }}</span>
            </div>
            <div class="d-flex underline" (click)="openInventory('PlayerCull',5)">
              <sb-icon icon="screen" [dualColor]="true" class="mr-2"></sb-icon>
              &nbsp;<span>{{ getText('screens') }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'ClientCull'" class="w-100 text-center">
          <div class="d-flex underline">
            <sb-icon icon="companyClient" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('clients') }}</span>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'ContentCull'" class="w-100 text-center">
          <div class="d-flex underline">
            <sb-icon icon="companyClient" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('publishers') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="company" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('advertisers') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="megaphone" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('campaigns') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="commercial" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('commercials') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="crossway" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('requirements') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="bookings" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('bookings') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="motive" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('motives') }}</span>
          </div>
          <div class="d-flex underline">
            <sb-icon icon="motives" [dualColor]="true" class="mr-2"></sb-icon>
            &nbsp;<span>{{ getText('motiveGroups') }}</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
